import { forwardRef } from "react";
import NavigationContainer from "./components/NavigationContainer";

export default forwardRef((props, ref) => {
    return (<NavigationContainer ref={ref} {...props} />);
});
